export default __webpack_public_path__ + "static/media/595.c1d3de85.jpg";